<div *ngIf="loading">
    <app-spinner></app-spinner>
</div>
<div *ngIf="!loading">
    <div class="mini-nav">
        <h1>Topics</h1>
        <div class="spacer"></div>
    
        <div class="menu">
            
            <a routerLink="/feed/episodes" routerLinkActive="active">
            <img src="assets/icons-2019/shows.svg" />
            Episodes
            </a>
            <a routerLink="/feed/clips" routerLinkActive="active">
            <img src="assets/icons-2019/shows.svg" />
            Clips
            </a>
            <a routerLink="/topics" routerLinkActive="active">
            <img src="assets/icons-2019/topics.svg" />
            Topics
            </a>
        </div>
    </div>
    
    <ng-container  *ngFor="let category of categories">
        <div class="topics">
            <a routerLink="/topics/{{topic.slug}}" 
                class="topic" 
                [class.has-own-thumbnail]="topic.item.thumbnail" 
                [responsiveBackgroundImage]="topic.thumbnail_square" 
                *ngFor="let topic of topicsOfType(category.type); index as i" 
                [attr.data-shutter-order]="i"
                [class.biggest]="i % 6 < 2"
                >
                <div class="overlay"></div>
                <div class="gradient"></div>
                <div class="title-gradient"></div>
                <div class="content-box">
                    <div class="name">
                    {{topic.name}}
                    </div>

                    <div class="item">
                        <h2>LATEST</h2>
                        <div class="title">
                            {{topic.item.title | summarize}}
                        </div>
                        <div class="show">
                            {{topic.item.date | date : 'MMMM d'}} | {{topic.item.brand_name}}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </ng-container>
</div>